var resizeTimer;
var slide_wrappers = '.slider-blocks, .slide_wrapper';

$(window).resize(function(){
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function(){
    smartSize();
  }, 1000)
})

$(slide_wrappers).on('mousedown touchstart', function (e) {
    //e.preventDefault();
    xDown = e.pageX || e.originalEvent.touches[0].pageX;
}).on('mouseup touchend',function (e) {
    xUp = e.pageX || e.originalEvent.changedTouches[0].pageX;
    if(xDown != xUp && diff(xDown, xUp) > 50){
        if(xDown > xUp){
            swipe('left', $(this))
        }else{
            swipe('right', $(this))
        }
    }
});

function diff(a,b){return Math.abs(a-b);}

function swipe(way, div){
   if($(window).width() < 1024){
     var active_element = $(div).parent().parent().find('.slider-dots').find('.active').index();
     var total_elements = $(div).parent().parent().find('.slider-dots > div').length;
     console.log(total_elements)

     if(way == 'left'){
       console.log('Swipe Left on '+$(div).attr('class'))
       var new_element = active_element+1;
       if(new_element < total_elements){
         $(div).parent().parent().find('.slider-dots > div').eq(new_element).trigger('click');
       }
     }else{
       console.log('Swipe Right on '+$(div).attr('class'))
       var new_element = active_element-1;
       if(new_element >= 0){
         $(div).parent().parent().find('.slider-dots > div').eq(new_element).trigger('click');
       }
     }

   }
}

function smartSize(){
  if($(window).width() < 1024){
    var maxHeight = 0;
    $(slide_wrappers).find('ul > li > div > p, ul > li > div > div.p').stop(true,true).height('');
    $(slide_wrappers).find('ul > li > div > p, ul > li > div > div.p').each(function() {
      maxHeight = maxHeight > $(this).outerHeight(true) ? maxHeight : $(this).outerHeight(true);
    });
    $(slide_wrappers).find('ul > li > div > p, ul > li > div > div.p').stop(true,true).outerHeight(maxHeight);
  }else{
    $(slide_wrappers).find('ul').css({ transform: 'translate3d(0px, 0px, 0px)'})
    $(slide_wrappers).find('ul > li > div > p, ul > li > div > div.p').stop(true,true).height('auto');
  }
}

$('.slider-dots > div').bind({
    click: function(){
      $(this).parent().find('.active').removeClass('active');
      var ind = $(this).index();
      var div = $(this).parent().parent().find(slide_wrappers);
      $(this).addClass('active');
      setSmartSlide(ind, div);
    }
})

function setSmartSlide(ind, div){
  $(div).data('cur', ind);
  smartSlide(div)
}

function smartSlide(div){
  var pos = $(div).data('cur');
  var slide_width = $(div).find('ul > li').eq(pos).outerWidth(true)+4;
  var x = -(slide_width*pos);
  $(div).find('ul').css({ transform: 'translate3d('+x+'px, 0px, 0px)'});
}

smartSize();
